/** Hardcoded homepage content from website/index.php (React routes, /app asset paths). */

export const QUICK_SERVICES = [
  {
    title: 'Flight Status',
    to: '/flights#flights-board',
    color: '#0F3E8A',
    path: 'M12 19V5M5 12l7-7 7 7',
  },
  {
    title: 'Arrivals',
    to: '/flights?dir=arr#flights-board',
    color: '#37B4E6',
    path: 'M12 5v14M5 12l7 7 7-7',
  },
  {
    title: 'Departures',
    to: '/flights?dir=dep#flights-board',
    color: '#F5A623',
    path: 'M5 12h14M12 5l7 7-7 7',
  },
  {
    title: 'Parking',
    to: '/parking',
    color: '#0A2A5C',
    path: 'M3 7h18v10H3zM7 17v3M17 17v3',
  },
  {
    title: 'Rental Services',
    to: '/transport',
    color: '#0F3E8A',
    path: 'M4 16h16v2H4zM6 16l2-5h8l2 5M9 11V9h6v2M8 18v1M16 18v1',
  },
  {
    title: 'Baggage',
    to: '/baggage',
    color: '#37B4E6',
    path: 'M6 8h12v11H6zM9 8V6h6v2',
  },
  {
    title: 'Airport Map',
    to: '/airport-map',
    color: '#F5A623',
    path: 'M12 21s7-5.5 7-11a7 7 0 10-14 0c0 5.5 7 11 7 11z',
  },
  {
    title: 'Lounges',
    to: '/lounges',
    color: '#0A2A5C',
    path: 'M4 10h16v8H4zM7 10V7a5 5 0 0110 0v3',
  },
];

export const INFO_CARDS = [
  {
    title: 'Terminal information',
    description:
      'Gates, wayfinding, check-in zones, and facilities across the terminal.',
    image: '/images/airport/airport-terminal-lobby.jpg',
    ctaLabel: 'View map',
    to: '/airport-map',
  },
  {
    title: 'Passenger guide',
    description:
      'Arrival and departure essentials — security, immigration, and connections.',
    image: '/images/airport/airport-exterior-view.jpg',
    links: [
      { label: 'Arrival', to: '/arrival-guide' },
      { label: 'Departure', to: '/departure-guide' },
    ],
  },
  {
    title: 'Travel information',
    description: 'Visa guidance, documents, and border formalities before you fly.',
    image: '/images/airport/airport-check-in-counters.jpg',
    ctaLabel: 'Explore',
    to: '/visa-info',
  },
];

export const PASSENGER_SERVICES = [
  {
    title: 'Baggage services',
    description: 'Track, reclaim, and wrap with confidence.',
    image: '/images/airport/departure-check-in-area.jpg',
    to: '/baggage',
  },
  {
    title: 'Lost & found',
    description: 'Report missing items before leaving the terminal.',
    image: '/images/airport/departure-check-in-area.jpg',
    to: '/baggage',
  },
  {
    title: 'Special assistance',
    description: 'Mobility and accessibility support on request.',
    image: '/images/airport/airport-terminal-lobby.jpg',
    to: '/special-assistance',
  },
  {
    title: 'Visa services',
    description: 'Entry guidance and document reminders.',
    image: '/images/airport/airport-check-in-counters.jpg',
    to: '/visa-info',
  },
  {
    title: 'Medical services',
    description: 'First aid and on-site medical support.',
    image: '/images/airport/airport-check-in-counters.jpg',
    to: '/assistance',
  },
  {
    title: 'Meet & greet',
    description: 'Personalised arrival and departure assistance.',
    image: '/images/airport/airport-vip-lounge-seating.jpg',
    to: '/vip-service',
  },
];

export const FACILITIES = [
  {
    title: 'Restaurants',
    image: '/images/airport/airport-premium-lounge-dining.jpg',
    to: '/dining',
  },
  {
    title: 'Cafés',
    image: '/images/airport/airport-premium-lounge-dining.jpg',
    to: '/dining',
  },
  {
    title: 'Shopping',
    image: '/images/airport/airport-shopping-area.jpg',
    to: '/shopping',
  },
  {
    title: 'Duty free',
    image: '/images/airport/airport-shopping-area.jpg',
    to: '/duty-free',
  },
  {
    title: 'Prayer room',
    image: '/assets/airport/prayer-room.jpg',
    to: '/facilities-services',
  },
  {
    title: 'Currency exchange',
    image: '/images/airport/airport-terminal-lobby.jpg',
    to: '/overseas-payment',
  },
  {
    title: 'ATM',
    image: '/images/airport/airport-terminal-lobby.jpg',
    to: '/overseas-payment',
  },
  {
    title: 'VIP lounge',
    image: '/images/airport/airport-vip-lounge-seating.jpg',
    to: '/vip-service',
  },
  {
    title: 'Smoking area',
    image: '/images/airport/airport-exterior-view.jpg',
    to: '/facilities-services',
  },
  {
    title: 'Business lounge',
    image: '/images/airport/airport-business-lounge.jpg',
    to: '/lounges',
  },
];

export const EXPLORE_PLACES = [
  {
    title: "Banc d'Arguin",
    image: '/assets/mauritania/banc-darguin.jpg',
    to: '/attractions#banc-darguin',
  },
  {
    title: 'Chinguetti',
    image: '/assets/mauritania/chinguetti.jpg',
    to: '/attractions#chinguetti',
  },
  {
    title: 'Terjit Oasis',
    image: '/assets/mauritania/terjit.jpg',
    to: '/attractions#terjit',
  },
  {
    title: 'Nouakchott Beach',
    image: '/assets/mauritania/nouakchott.jpg',
    to: '/attractions#nouakchott',
  },
  {
    title: 'Iron Ore Train',
    image: '/assets/mauritania/iron-ore-train.jpg',
    to: '/attractions#iron-ore-train',
  },
  {
    title: 'National Museum',
    image: '/assets/mauritania/mauritania-attractions.jpg',
    to: '/attractions#nouakchott',
  },
];

/** Unique partner codes — marquee UI should duplicate the list. */
export const AIRLINE_LOGOS = ['l6', 'af', 'tk', 'et', 'qr', 'ms', 'kl', 'lh'];

export const NEWS_ITEMS = [
  {
    category: 'Operations',
    date: '23 Jul 2026',
    title: 'Summer schedule enhancements at NKC',
    image: '/images/airport/departure-check-in-area.jpg',
    to: '/news',
  },
  {
    category: 'Passenger',
    date: '18 Jul 2026',
    title: 'New wayfinding improvements across the terminal',
    image: '/images/airport/airport-terminal-lobby.jpg',
    to: '/news',
  },
  {
    category: 'Community',
    date: '10 Jul 2026',
    title: 'Experience Mauritania: weekend travel ideas',
    image: '/assets/hm-sahara-atlantic.jpg',
    to: '/news',
  },
];

export const STATS = [
  { count: 1800000, label: 'Passengers / year' },
  { count: 24000, label: 'Flights / year' },
  { count: 28, label: 'Destinations' },
  { count: 16, label: 'Airlines' },
];

export const WHY_ITEMS = [
  {
    title: 'Safety',
    description: 'International standards and careful operational oversight.',
    to: '/security',
  },
  {
    title: 'Comfort',
    description: 'Lounges, prayer rooms, and calm spaces to wait.',
    to: '/lounges',
  },
  {
    title: 'Connectivity',
    description: 'Regional and intercontinental links through NKC.',
    to: '/destinations',
  },
  {
    title: 'Modern infrastructure',
    description: 'Clear wayfinding and evolving terminal amenities.',
    to: '/airport-map',
  },
];

export const TESTIMONIALS = [
  {
    name: 'Amine D.',
    initials: 'AD',
    meta: 'Arrival · Casablanca → NKC',
    quote:
      'Smooth arrival experience — clear signage and friendly staff from the moment I stepped into the terminal.',
  },
  {
    name: 'Sarah K.',
    initials: 'SK',
    meta: 'Departure · Lounge guest',
    quote:
      'The lounge was calm, the flight board was easy to follow, and boarding felt organised and on time.',
  },
  {
    name: 'Ibrahim M.',
    initials: 'IM',
    meta: 'Transit · Connecting passenger',
    quote:
      'A great gateway to Mauritania. Immigration queues moved quickly and the terminal felt modern and welcoming.',
  },
  {
    name: 'Léa R.',
    initials: 'LR',
    meta: 'Family travel · Paris → NKC',
    quote:
      'Travelling with children was easier than expected — helpful staff, clean facilities, and clear wayfinding throughout.',
  },
  {
    name: 'Omar B.',
    initials: 'OB',
    meta: 'Business · Frequent flyer',
    quote:
      'Check-in was efficient and the business lounge gave me a quiet place to work before my evening flight.',
  },
  {
    name: 'Fatima S.',
    initials: 'FS',
    meta: 'First visit · Tourism',
    quote:
      'My first time through NKC felt reassuring — bright spaces, helpful information desks, and a calm atmosphere.',
  },
];
